import React from "react";

import building from "../../Assets/images/building.png";
import laptop from "../../Assets/images/laptop.png";
import mobile from "../../Assets/images/mobile.png";
import { Link } from "react-router-dom";
import { api_url } from "../../Constants/web_services";

const HomeWork = () => {
  return (
    <>
      <section className="bg-white aon-how-service-area sf-curve-pos">
        <div className="container">
          <div className="section-content">
            <div className="row">
              {/*Title Section Start*/}
              <div className="col-lg-4 col-md-12">
                <span className="aon-sub-title">Steps</span>
                <h2 className="sf-title">How Service Finder Works</h2>
              </div>
              {/*Title Section End*/}
              <div className="col-lg-8 col-md-12">
                {/* Steps Block Start*/}
                <div className="aon-step-blocks">
                  <div className="row">
                    {/* COLUMNS 1 */}
                    <div className="col-md-4 col-sm-4 m-b30">
                      <div className="aon-step-section step-position-1 aon-icon-effect">
                        <div className="aon-step-icon aon-icon-box">
                          <Link to={"/search"} target="_blank">
                            <span>
                              <i className="aon-icon">
                                <img src={mobile} alt="" width={"65px"} />
                              </i>
                            </span>
                          </Link>
                        </div>
                        <div className="aon-step-info">
                          <h4 className="aon-title s-18 fw-700 text-022279">
                            Get Work Done
                          </h4>
                          <p>Make Your Mobile Your Business Gateway</p>
                        </div>
                      </div>
                    </div>
                    {/* COLUMNS 2 */}
                    <div className="col-md-4 col-sm-4 m-b30">
                      <div className="aon-step-section step-position-2 aon-icon-effect">
                        <div className="aon-step-icon">
                          <Link to={"/search"}>
                            <span>
                              <i className="aon-icon">
                                <img src={laptop} alt="" width={"75px"} />
                              </i>
                            </span>
                          </Link>
                        </div>
                        <div className="aon-step-info">
                          <h4 className="aon-title s-18 fw-700 text-022279">
                            Get Work Done
                          </h4>
                          <p>
                            Find you Best Company To make your Idea in Visual
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* COLUMNS 3 */}
                    <div className="col-md-4 col-sm-4 m-b30">
                      <div className="aon-step-section  step-position-3  aon-icon-effect">
                        <div className="aon-step-icon">
                          <Link to={api_url} target="_blank">
                            <span>
                              <i className="aon-icon mr-1">
                                <img src={building} alt="" width={"160px"} />
                              </i>
                            </span>
                          </Link>
                        </div>
                        <div className="aon-step-info">
                          <h4 className="aon-title s-18 fw-700 text-022279">
                            Get Business
                          </h4>
                          <p>Register Your Company Get More Business</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Steps Block End*/}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeWork;
